<od-engagements-indemnites #indemnites [contexte]="Contexte.FRAIS" [od]="od" [canModifier]="canModifier" [canCompleter]="canCompleter"
                           (onDegrevementsChanged)="refreshOnChangeDegrevements()"></od-engagements-indemnites>
